import { getUserContext } from '@cbhq/client-analytics';
import { Client, init } from '@cbhq/error-vitals-web';

let ErrorVitalsClient: Client | undefined;

if (typeof window !== 'undefined') {
  try {
    ErrorVitalsClient = init({
      apiKey: String(process.env.NEXT_PUBLIC_ERROR_VITALS_API_KEY),
      environment: String(process.env.NEXT_PUBLIC_ANALYTICS_ENVIRONMENT),
      appVersion: String(process.env.NEXT_PUBLIC_VERSION),
      useGlobalHandlers: true,
      getUserContext,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error initializing Error Vitals', error);
  }
}

export function getErrorVitals() {
  return ErrorVitalsClient;
}
